import { FunctionComponent, useEffect, useState } from 'react'
import { Alert, Container, Spinner } from 'react-bootstrap'

import { hasActiveBi } from 'features/doctors/types'
import * as userApi from 'features/user/api.client'
import styles from './style.module.scss'

const BiMedico: FunctionComponent = () => {
  const [urlBi, setUrlBi] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadUrl = async () => {
      try {
        const user = await userApi.get()
        setUrlBi(hasActiveBi(user) ? user.urlBi || null : null)
      } finally {
        setLoading(false)
      }
    }

    loadUrl()
  }, [])

  if (loading) {
    return (
      <Container fluid className={styles.container}>
        <Spinner animation="border" size="sm" />
      </Container>
    )
  }

  if (!urlBi) {
    return (
      <Container fluid className={styles.container}>
        <Alert variant="warning">Bi Médico não disponível.</Alert>
      </Container>
    )
  }

  return (
    <Container fluid className={styles.container}>
      <div className={styles.biFrameWrap}>
        <iframe
          title="Bi Médico"
          src={urlBi}
          className={styles.biFrame}
          allowFullScreen
        />
        <div className={styles.biBrandCover} aria-hidden="true" />
      </div>
    </Container>
  )
}

export default BiMedico
